let resetNotifications = (state) => {
    let chat = state.chats.find((chat) => chat.id === localStorage.getItem('currentChatId'));
    chat.notifications = 0;
};

export default resetNotifications;